import { Fade } from "react-awesome-reveal";
import type { SkillCardProps } from '../store/types';

const SkillCard = ({
    title,
    items,
    delay = 100,
}: SkillCardProps) => {
    return (
        <div className={"col-lg-6 mt-3 skills px-1"}>
            <Fade triggerOnce delay={delay}>
                <div className={"bg-light border-radius-25 p-4 h-100"}>
                    <h5 className="fw-700 mb-3">{title}</h5>
                    <p className="fw-600">
                        {items.map((item, index) => (
                            <span key={`${title}-${item}`}>
                                <span className="text-green"><b>- </b></span> &nbsp;
                                {item}
                                {index < items.length - 1 ? <br /> : null}
                            </span>
                        ))}
                    </p>
                </div>
            </Fade>
        </div>
    );
};

export default SkillCard;
